import React, { useCallback, useState } from "react";
import HoverTooltip from "../HoverTooltip";

export function TruncatedText({ children }: { readonly children: React.ReactNode }): React.ReactElement {
  const [tooltipContent, setTooltipContent] = useState("");

  const handleMouseEnter = useCallback((event: React.MouseEvent<HTMLSpanElement>): void => {
    const textElement = event.currentTarget.querySelector<HTMLElement>(".Polaris-Text--truncate");
    setTooltipContent(textElement.scrollWidth > textElement.clientWidth ? textElement.innerText : "");
  }, []);

  const handleMouseLeave = useCallback((): void => {
    setTooltipContent("");
  }, []);

  return (
    <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {tooltipContent ? (
        <HoverTooltip active content={tooltipContent} preferredPosition="above">
          {children}
        </HoverTooltip>
      ) : (
        children
      )}
    </span>
  );
}
